<div class="section">
  @if (user) {
    <button class="hamburger" nbButton ghost status="basic" (click)="toggleSidebar()" aria-label="Menu">
      <nb-icon icon="menu-outline"></nb-icon>
    </button>
  }
  <div class="logo">
    @if (logo && !logoBroken) {
      <a class="company-link" routerLink="/">
        <img [src]="logo" [alt]="'logo'" (error)="logoBroken = true">
      </a>
    }
    <a class="software-link" routerLink="/">
      @if (!logo || logoBroken) {
        <img src="assets/teamertime-solo.png" alt="TeamerTime" class="header-brand-logo">
      }
      <span class="brand-name">{{ titleService.titles[0] || title }}</span>
    </a>
    @for (t of titleService.titles.slice(1); track $index){
      <span class="software-link sub sep">
        &#8250;
      </span>
      <a class="software-link sub">
        <span class="crumb">{{ t }}</span>
      </a>
    }
  </div>
</div>
@if (user) {
  <div class="section">
    @if (Globals.isLoading) {
      <div class="loading">
        <nb-spinner status="basic" [message]="((Globals.whatLoading || 'loading') | translate) + '…'" size="large"></nb-spinner>
      </div>
    }
    <!--  <bst-search-field [focus]="searching" [class.focused]="searching.getValue()"></bst-search-field>-->
    <div class="section userinfo" #accountControl>
      <button type="button" class="account-trigger" #accountTrigger
              [attr.aria-label]="'shell.account_menu' | translate"
              [attr.aria-expanded]="accountMenuOpen" aria-controls="account-menu"
              (click)="accountMenuOpen = !accountMenuOpen">
        <nb-user size="medium" [picture]="userlogo(user)" [name]="(user.name_first ?? '') + ' ' + (user.name_last ?? '')" [title]="user.username"></nb-user>
        <nb-icon icon="chevron-down-outline" aria-hidden="true"></nb-icon>
      </button>
      <div id="account-menu" class="account-menu" role="navigation" [hidden]="!accountMenuOpen" [attr.aria-label]="'shell.account_menu' | translate">
        <nb-menu tag="usermenu" [items]="usermenu"></nb-menu>
      </div>
    </div>
    <button class="kebab" nbButton ghost status="basic"
            [nbPopover]="mobileMenuTpl" nbPopoverTrigger="click" nbPopoverPlacement="bottom"
            #mobilePop="nbPopover"
            [attr.aria-label]="'shell.more_actions' | translate">
      <nb-icon icon="more-vertical-outline"></nb-icon>
    </button>
    <ng-template #mobileMenuTpl>
      <div class="kebab-popup">
        @for (it of mobilemenu; track it.title) {
          <a class="kebab-item" [href]="it.url" [attr.target]="it.target" (click)="hideMobileMenu()">
            @if (it.icon) { <nb-icon [icon]="it.icon"></nb-icon> }
            {{ it.title }}
          </a>
        }
      </div>
    </ng-template>
  </div>
}
@if (!user) {
  <div class="section">
    <!--  <a class="login" [routerLink]="'/login'">-->
    <!--    <nb-icon icon="person"></nb-icon><span>{{ 'login' | translate }}</span>-->
  <!--  </a>-->
  <div class="languages" role="group" [attr.aria-label]="'language' | translate">
    <nb-icon icon="globe-outline"></nb-icon>
    @for (lang of languages; track lang) {
      <button type="button" [class.active]="lang === translate.currentLang" [attr.aria-pressed]="lang === translate.currentLang" [attr.lang]="lang" [title]="lang | translate" (click)="setLanguage(lang)">{{ lang.toUpperCase() }}</button>
    }
  </div>
  <button class="login" shape="semi-round" outline nbButton status="basic" size="small" [routerLink]="'/login'">
    <nb-icon icon="person"></nb-icon><span>{{ 'login' | translate }}</span>
  </button>
  <button class="register" shape="semi-round" nbButton status="primary" size="small" [routerLink]="'/register'">
    <nb-icon icon="person-add"></nb-icon><span>{{ 'register' | translate }}</span>
  </button>
</div>
}
